import { Button } from "@mui/material"
import { Helmet } from "react-helmet"
import { Route, Routes, useNavigate } from "react-router-dom"
import { Copyrightpolicy, Privacypolicy, Servicepolicy } from "./policies_info"


export const CompanyPolicies = () =>{
    const navigate = useNavigate()

    return (
        <div>
            <div className="landing_images_6 landing_center" id="site_cover_image">
                <Helmet>
                    <title>DGA | Policies</title>
                </Helmet>
                <div className="company_details">
                    <div className="company_name smaller_company_name" id="company_name">
                        Policies
                    </div>
                    <div className="tag_line">
                        We are concerned about you
                    </div>
                </div>
                <div className="navigation_on_home_container">
                </div> 
            </div>

            <div className="packages_main middle_component" style={{marginTop:'0px'}}>
				<div className="packs_window">
                <div style={{display:'flex', flexDirection:"row", justifyContent:'space-around'}}>
                            <p>
                                <Button onClick={()=>navigate("privacy_policy")}>Privacy Policy</Button>
                            </p>
                            <p>
                            <Button onClick={()=>navigate("service_policy")}>Service Policy</Button>
                            </p>
                            <p>
                                <Button onClick={()=>navigate("copyright_policy")}>Copyright Policy</Button>
                            </p>
                </div>
                <div className="paper">

                    <Routes>
                        <Route path="" element={<Policies />} />
                        <Route path="privacy_policy" element={<Privacypolicy />} />
                        <Route path="service_policy" element={<Servicepolicy />} />
                        <Route path="copyright_policy" element={<Copyrightpolicy />} />
                    </Routes>
                </div>
				</div>
			</div>
        </div>
    )
}

const Policies = () => {
    return (<>
    <h1>
        WE CARE ABOUT YOU. Ensure you read and understand Our policies to serve you better.
    </h1>
    </>
    )
}

